import { FunctionComponent } from "react";

import { ListSourceType } from "@/enum/list.enum";

import { CustomEvent } from "@/pages/Private/pages/CustomEvent/schema/customEvent";
import { Map } from "@/pages/Private/pages/Map/schema/map";
import { CsvEnrichment } from "@/pages/Private/pages/CsvEnrichment/schema/csvEnrichment";
import { Job } from "@/pages/Private/pages/Job/schema/job";
import { LiCompanyActivity } from "@/pages/Private/pages/LiCompanyActivity/schema/liCompanyActivity";
import { LiEvent } from "@/pages/Private/pages/LiEvent/schema/liEvent";
import { LiPeople } from "@/pages/Private/pages/LiPeople/schema/liPeople";
import { LiPost } from "@/pages/Private/pages/LiPost/schema/liPost";
import { LiProfileVisits } from "@/pages/Private/pages/LiProfileVisits/schema/liProfileVisits";

import { CreateLiProfileVisitsForm } from "@/pages/Private/pages/LiProfileVisits/components/CreateLiProfileVisitsForm";

import { LiSn } from "@/pages/Private/pages/LiSn/schema/liSn";

import { StepInfo } from "@/components/StepInfo/StepInfo";

import { AddedSourceList } from "../../../components/AddedSourceList";
import { List } from "../../../schema/list";

export interface LiProfileVisitsSourceProps {
	data: List;

	selected:
		| Map
		| Job
		| CsvEnrichment
		| LiEvent
		| LiCompanyActivity
		| LiPost
		| LiProfileVisits
		| LiPeople
		| LiSn
		| CustomEvent
		| null;
	setSelected: (
		map:
			| Map
			| Job
			| CsvEnrichment
			| LiEvent
			| LiCompanyActivity
			| LiPost
			| LiProfileVisits
			| LiPeople
			| LiSn
			| CustomEvent
			| null
	) => void;
}

export const LiProfileVisitsSource: FunctionComponent<LiProfileVisitsSourceProps> = ({
	data,
	selected,
	setSelected,
}) => {
	if (data.sourceType === ListSourceType.LI_PROFILE_VISITS) {
		return (
			<>
				<StepInfo
					description={
						<>
							<p>
								In Signalist you begin by specifying the LinkedIn profile you want to track and the
								date from which visitor data should be collected. You then assign one or more
								Signalist users to that tracking campaign, define your lead-qualification criteria,
								and configure whether it should run once or recur daily. Finally, you set limits on
								how many leads to gather (per day or in total), determine when the campaign should
								stop, and choose whether to fetch email addresses and adjust any additional options.
							</p>
						</>
					}
					title="How to track your LinkedIn Profile Visitors"
					videoId="BihqNUeUF1I"
				/>
				<div className="flex flex-row gap-12">
					<div className="grow relative">
						{selected ? (
							<CreateLiProfileVisitsForm
								handleSelect={setSelected}
								liProfileVisits={selected as LiProfileVisits}
								list={data as List}
							/>
						) : (
							<CreateLiProfileVisitsForm list={data as List} />
						)}
					</div>
					<div className="w-1/2">
						<AddedSourceList handleSelect={setSelected} list={data as List} />
					</div>
				</div>
			</>
		);
	}

	return <></>;
};
